module.exports = __webpack_public_path__ + "static/images/jf-activity-bg02.5a8cac3.png";